export default __webpack_public_path__ + "static/error-cd8b68f5bde2f183807833b5dfb30499.svg";